var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GeneralSalesScreen',{attrs:{"outsideTypeSale":_vm.outsideTypeSale}})
}
var staticRenderFns = []

export { render, staticRenderFns }